import { Helmet } from 'react-helmet';
import {
    Box,
    Button,
    Card,
    CardHeader,
    CardActions,
    CardContent,
    Chip,
    Container,
    Divider,
    Checkbox,
    Grid,
    Typography,
    Paper,
    TextField,
    Switch,
    FormGroup,
    FormControlLabel,
    MenuItem,
    Select,
    FormHelperText,
    Autocomplete,
    Stack,
    FormControl,
    ListSubheader,
    InputAdornment,
    ClickAwayListener,
    Collapse
} from '@mui/material';
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useMemo, useCallback } from "react";
import { Link as RouterLink, useNavigate, useParams } from "react-router-dom";
import { makeStyles, styled } from "@mui/styles";
import emtyData from "../../../../assets/images/emty-data.png";
import { Formik } from "formik";
import * as Yup from 'yup';
import DialogIcon from "../../../../components/kpi/DialogIcon";
import { useFormik } from 'formik';
import * as yup from 'yup';
import * as Util from "../../../../services/global.service";
import { ReactComponent as Dropdown } from "../../../../assets/images/dropdown.svg";
import Icon from '@mui/material/Icon';
import SimpleDialog from "../../../../components/SimpleDialog";
import ConfirmDialog from "../../../../components/ConfirmDialog";
import MessageDialog from "../../../../components/inbox/MessageDialog";
import { ReactComponent as PlusIcon } from "../../../../assets/icons/plus.svg";
import { ReactComponent as Delete } from "../../../../assets/icons/delete.svg";
import { ReactComponent as Calendar } from "../../../../assets/icons/calendar.svg";
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { ReactComponent as Eye } from "../../../../assets/images/eye.svg";
import DialogPreview from "../../../../components/kpi/DialogPreview";
import adminService from "../../../../services/admin.service";
import calibrationService from "../../../../services/calibration.service";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers';
// import DatePicker from '@mui/lab/DatePicker';
import Search from "@mui/icons-material/Search";
import { ReactComponent as Nodata } from "../../../../assets/icons/nodata.svg";
import debounce from 'lodash.debounce';
import ClearIcon from "@mui/icons-material/Clear";
import IconButton from "@mui/material/IconButton";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const styles = {
    path: {
        color: "#68717A",
    },
    icon: {
        color: "#6B6B6B",
        marginBottom: "-3px",
        marginRight: "10px",
    },
    link: {
        color: "#5DA196",
        cursor: "pointer",
    },
    end: {
        color: "#A3A3A3",
    },
    buttonFile: {
        position: "absolute",
        right: "1px",
        top: "1px",
        // bottom: "9px",
        background: "linear-gradient(0deg, #E5E9EC, #E5E9EC), #404349",
        borderLeft: "1px solid #CED4DA",
        "border-radius": "0px 4px 4px 0px",
        width: "100px",
        color: "#404349",
        fontSize: "16px",
        // lineHeight: "23.92px",
        fontWeight: "300"
    },
    dropdowm: {
        position: "absolute",
        right: "20px",
        top: "40%",
        // bottom: "9px",
        color: "#404349",
        fontSize: "16px",
        // lineHeight: "23.92px",
        fontWeight: "300"
    },
};

const CalibrationSessionCreate = (props) => {
    const { t } = useTranslation();

    useEffect(() => {
        getListCriteria()
        getListFormCalibrationTemplete()
        getListDropdownManager()
    }, []);
    // position: absolute; bottom: -24px
    const useStyles = makeStyles({
        iconContainer: {
            '& svg': {
                width: "45px",
                height: "45px"
            }
        },
        formTextField: {
            '& .MuiTextField-root': { m: 1, width: '25ch' },
        },
        fieldsetError: {
            '& div > fieldset': {
                "border-color": "#CC6058"
            }
        },
        input: {
            '& div > input': {
                height: '8px',
                position: "relative"
            }
        },
        inputTopic: {
            "margin-top": "0px !important",
            "margin-bottom": "0px !important",
            '& div > input': {
                padding: "12px 14px",
                "font-size": "16px",
                height: '8px',
                position: "relative"
            }
        },
        inputTopicError: {
            "margin-top": "0px !important",
            "margin-bottom": "0px !important",
            '& div > input': {
                padding: "12px 14px",
                "font-size": "16px",
                height: '8px',
                position: "relative"
            },
            '& fieldset': {
                "border-color": "#CC6058"
            }
        },
        select: {
            '& div ': {
                padding: "8.5px 8.5px 8.5px 15px"
            },
        },
        selectError: {
            background: "#CC6058",
            '& div ': {
                padding: "8.5px 8.5px 8.5px 15px"
            },
            '& fieldset': {
                "border-color": "#CC6058"
            },
        },
        inputError: {
            '& div > input': {
                color: "#CC6058",
                background: "#CC60581A",
                textAlign: "center",
                height: '6px',
                border: "1px solid #CC6058 !important",
                borderRadius: "4px"
            }
        },
        width50: {
            width: "calc(50% - 80px)",
            margin: "0 40px",
        },
        width100: {
            width: "calc(50% - 80px)",
            margin: "0 40px",
        },
        boxInput: {
            ".MuiFormControl-root": {
                "margin-top": "7px"
            }
        },
        styleTag: {
            '& div > .MuiOutlinedInput-root': {
                '& .MuiChip-root': {
                    backgroundColor: "#5DA196",
                    color: "#ffffff",
                    borderRadius: "3px",
                    '& .MuiChip-deleteIcon': {
                        color: "#ffffff",
                    }
                },
            },
        },
        flexPaper: {
            flex: 1,
            minWidth: 350,
            "border-radius": "10px !important"
        },
        root: {
            display: 'flex',
            flexWrap: 'wrap',
            marginTop: "25px"
        },
        fillGrey: {
            '& > path': {
                fill: "#D8D8D8 !important",
            },
            '& g > path': {
                fill: "#D8D8D8 !important",
            },
        },
        fillGreyStroke: {
            '& > path': {
                stroke: "#D8D8D8 !important"
            },
            '& g > path': {
                stroke: "#D8D8D8 !important"
            },
        },
    })
    const navigate = useNavigate();
    const clickLink = (data) => {
        navigate(data, { replace: false, state: { cycleID: cycleID } });
    }
    const classes = useStyles();
    let { cycleID } = useParams()
    const [criteria, setCriteria] = React.useState([]);
    const [forManager, setForManager] = React.useState([]);
    const [status, setStatus] = React.useState(true);
    const [onSubmit, setOnSubmit] = React.useState(false);
    const [checkCode, setCheckCode] = React.useState(false);
    const [valueCriteria, setValueCriteria] = React.useState("");
    const [valueSubCriteria, setValueSubCriteria] = React.useState([]);
    const [ids, setIDS] = React.useState([]);
    const [idsDisplay, setIDSDisplay] = React.useState([]);
    const [startDate, setStartDate] = React.useState(null);
    const [endDate, setEndDate] = React.useState(null);
    const [errorText, seterrorText] = React.useState("");
    const [typeSubmit, setTypeSubmit] = React.useState("");
    const language = localStorage.getItem("lang");
    const onCheckStartDate = (val) => {
        setStartDate(Util.formatDate(val))
    }
    const onCheckEndDate = (val) => {
        setEndDate(Util.formatDate(val))
    }
    const handleStatus = () => {
        setStatus(!status)
    }

    const [listsType, setListsType] = React.useState({});
    const [formCalibrationTemplete, setFormCalibrationTemplete] = React.useState([]);
    const [calibrator, setCalibrator] = React.useState([]);
    const [approver, setApprover] = React.useState([]);
    const [filterOne, setFilterOne] = React.useState([]);
    const [filterTwo, setFilterTwo] = React.useState([]);
    const [dataFormExist, setDataFormExist] = React.useState([]);
    const [dataFormNotExist, setDataFormNotExist] = React.useState([]);
    const [validate, setValidate] = React.useState(false);

    const IOSSwitch = styled((props) => (
        <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
    ))(({ theme }) => ({
        width: "50px !important",
        height: "24px !important",
        padding: "0 !important",
        marginRight: "10px",
        '& .MuiSwitch-switchBase': {
            padding: 0,
            margin: "4px 6px",
            transitionDuration: '300ms',
            '&.Mui-checked': {
                transform: 'translateX(22px)',
                color: '#fff',
                '& + .MuiSwitch-track': {
                    backgroundColor: theme.palette.mode === 'dark' ? '#2ECA45' : '#5DA196',
                    opacity: 1,
                    border: 0,
                },
                '&.Mui-disabled + .MuiSwitch-track': {
                    opacity: 1,
                },
            },
            '&.Mui-focusVisible .MuiSwitch-thumb': {
                color: '#33cf4d',
                border: '6px solid #fff',
            },
            '&.Mui-disabled .MuiSwitch-thumb': {
                color:
                    theme.palette.mode === 'light'
                        ? theme.palette.grey[100]
                        : theme.palette.grey[600],
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                opacity: 1,
            },
        },
        '& .MuiSwitch-thumb': {
            boxSizing: 'border-box',
            width: 16,
            height: 16,
        },
        '& .MuiSwitch-track': {
            borderRadius: 26 / 2,
            backgroundColor: theme.palette.mode === 'light' ? '#C0C0C0' : '#39393D',
            opacity: 1,
            transition: theme.transitions.create(['background-color'], {
                duration: 500,
            }),
        },
    }));
    const validationSchema = yup.object({
        code: yup.string().required(t('admin.inputForm.msgError.code')),
        name: yup.string().max(255).required(t('admin.inputForm.msgError.nameTH')),
        startDate: yup.string().max(255).required(t('admin.inputForm.msgError.nameTH')).nullable(),
        endDate: yup.string().max(255).required(t('admin.inputForm.msgError.nameTH')).nullable(),
        formCalibrationTemplete: yup.string().max(255).required(t('admin.inputForm.msgError.pleaseSelect')),
        calibrator: yup.string().max(255).required(t('admin.inputForm.msgError.pleaseSelect')),
        // approver: yup.string().max(255).required(t('admin.inputForm.msgError.pleaseSelect')),
        filterOne: yup.string().max(255).required(t('admin.inputForm.msgError.pleaseSelect')),
        filterTwo: yup.string().max(255).required(t('admin.inputForm.msgError.pleaseSelect')),
    });

    const validationSchema2 = yup.object({
        formCalibrationTemplete: yup.string().max(255).required(t('admin.inputForm.msgError.pleaseSelect')),
        calibrator: yup.string().max(255).required(t('admin.inputForm.msgError.pleaseSelect')),
        // approver: yup.string().max(255).required(t('admin.inputForm.msgError.pleaseSelect')),
    });
    const formik = useFormik({
        initialValues: {
            code: '',
            // status: status,
            name: '',
            startDate: null,
            endDate: null,
            formCalibrationTemplete: '',
            calibrator: '',
            approver: '',
            filterOne: 'all',
            filterTwo: 'all',
            criteria: [],
        },
        enableReinitialize: true,
        validationSchema: validate ? validationSchema2 : validationSchema,
        onSubmit: (values) => {
            let checkDataCode = values.criteria.filter((rs) => rs.code === "")
            // let checkDataIds = values.criteria.filter((rs) => rs?.ids === undefined)
            // let checkDataIds2 = values.criteria.filter((rs) => rs?.ids.length === 0)
            if (checkDataCode.length === 0) {
                adminService.checkCode("calibration_session", values.code, cycleID).then(
                    (response) => {
                        setCheckCode(response?.data?.is_exist)
                        if (response?.data?.is_exist === false) {
                            submit(values)
                        }
                    },
                ).catch(() => {
                })
            }
        },
    });
    useEffect(() => {
        if (checkCode === true) {
            setCheckCode(false)
        }
    }, [formik.values.code]);
    const checkData = () => {
        let findDataCriteria = formik.values.criteria.length > 0 ? formik.values.criteria.filter((res) => res.type !== "" && res.code !== "") : []
        if (findDataCriteria !== undefined) {
            if (formik.values.criteria.length > 0) {
                // if (findDataCriteria !== undefined && findDataCriteria.length > 0 && findDataCriteria.length === formik.values.Criteria.length &&
                //     findDataForManager !== undefined && findDataForManager.length > 0 && findDataForManager.length === formik.values.forManager.length) {
                //     return true;
                // }
                return false;
            } else if (formik.values.criteria.length > 0 && findDataCriteria !== undefined && findDataCriteria.length > 0 && findDataCriteria.length === formik.values.criteria.length) {
                return true;
            }
        }
        return false;
    }
    const checkDataOne = (data) => {
        let findData = data.filter((res) => res.type !== "" && res.code !== "")
        if (findData !== undefined && findData.length > 0 && findData.length === data.length) {
            return true;
        }
        return false;
    }

    const handleSubmit = (type) => {
        setTypeSubmit(type)
        setValidate(false)
        let findDataCriteria = formik.values.criteria.filter((res) => res.type === "" && res.code === "")
        // let findDataForManager = formik.values.forManager.filter((res) => res.topic === "" && res.code === "")
        if (findDataCriteria !== undefined && findDataCriteria.length > 0) {
            let data = []
            for (let index = 0; index <= formik.values.criteria.length - 1; index++) {
                if (formik.values.criteria[index].code !== "" || formik.values.criteria[index].type !== "") {
                    if (formik.values.criteria[index].code === "" && formik.values.criteria[index].type === "") {

                    } else {
                        data.push(formik.values.criteria[index])
                    }
                }
            }
            setCriteria(data)
            formik.setFieldValue("criteria", data)
        }
        formik.submitForm()
        setOnSubmit(true)
    }
    const selectDate = (field, data) => {
        formik.setFieldValue(field, Util.formatDate(data))
    };
    useEffect(() => {
        addCriteria()
    }, [])
    const addCriteria = () => {
        setCriteria([...criteria, {}])
        formik.setFieldValue("criteria", [...formik.values.criteria, { type: "include", code: "" }])
    }
    const onCheckboxChange = (dataCheck, field, subField, index, type) => {
        let data = JSON.parse(JSON.stringify(formik.values))
        data[field][index] = { ...formik.values[field][index], "condition": formik.values[field][index].condition !== undefined && formik.values.criteria[index].code === "organization" ? { ...formik.values[field][index].condition, [subField]: dataCheck.target.checked } : { [subField]: dataCheck.target.checked } }
        formik.setFieldValue(field, data[field])
    }
    const formikChange = (val, field, subField, index, type) => {
        let data = JSON.parse(JSON.stringify(formik.values))
        let result = []
        let display = []
        if (subField === "ids") {
            for (let index = 0; index <= val.length - 1; index++) {
                result.push(val[index].serial)
                display.push(val[index])
                setIDSDisplay([...display])
                setIDS([...result])
            }
        }
        data[field][index] = { ...formik.values[field][index], [subField]: "ids" === subField ? [...result] : val.target.value, "idsDisplay": [...display], "condition": val?.target?.value === "organization" ? { "include_sub_organization": false } : {} }
        if (subField === "code") {
            if (val.target.value !== undefined && val.target.value !== null && val.target.value !== "") {
                calibrationService.listSubCriteria(val.target.value, cycleID).then(
                    (response) => {
                        setValueCriteria(val.target.value);
                        setValueSubCriteria({ ...valueSubCriteria, [val.target.value]: response.data[Object.keys(response.data).find((rs) => rs !== 'cycle')] !== undefined && response.data[Object.keys(response.data).find((rs) => rs !== 'cycle')].length > 0 ? [{ label: t('label.selectAll'), value: "select-all" }, ...response.data[Object.keys(response.data).find((rs) => rs !== 'cycle')]] : response.data[Object.keys(response.data).find((rs) => rs !== 'cycle')] });
                    },
                )
            }
        }
        if (subField === "type") {
            data[field][index] = { type: val.target.value, code: "" }
        }

        formik.setFieldValue(field, data[field])
        setDataFormExist([])
        setDataFormNotExist([])
        setSelected([])
    }

    const formikChangeOrganization = (val, field, subField, index, allData) => {
        let data = JSON.parse(JSON.stringify(formik.values))
        let result = []
        let display = []
        let findVal = val.filter((rs) => rs?.value === "select-all")
        let findAllData = allData.filter((rs) => rs?.value !== "select-all")
        if (subField === "ids" && findVal.length === 0) {
            for (let index = 0; index <= val.length - 1; index++) {
                result.push(val[index].serial)
                display.push(val[index])
                setIDSDisplay([...display])
                setIDS([...result])
            }
        }
        if (subField === "ids" && findVal.length > 0) {
            if (data[field][index][subField] === undefined) {
                for (let index = 0; index <= findAllData.length - 1; index++) {
                    result.push(findAllData[index].serial)
                    display.push(findAllData[index])
                    setIDSDisplay([...display])
                    setIDS([...result])
                }
            } else {
                if (data[field][index][subField].length >= 0 && findAllData.length > data[field][index][subField].length) {
                    for (let index = 0; index <= findAllData.length - 1; index++) {
                        result.push(findAllData[index].serial)
                        display.push(findAllData[index])
                        setIDSDisplay([...display])
                        setIDS([...result])
                    }
                }
            }

        }
        data[field][index] = { ...formik.values[field][index], [subField]: "ids" === subField ? [...result] : val.target.value, "idsDisplay": [...display] }
        if (subField === "code") {
            if (val.target.value !== undefined && val.target.value !== null && val.target.value !== "") {
                calibrationService.listSubCriteria(val.target.value, cycleID).then(
                    (response) => {
                        setValueCriteria(val.target.value);
                        setValueSubCriteria({ ...valueSubCriteria, [val.target.value]: response.data[Object.keys(response.data).find((rs) => rs !== 'cycle')] !== undefined && response.data[Object.keys(response.data).find((rs) => rs !== 'cycle')].length > 0 ? [{ label: t('label.selectAll'), value: "select-all" }, ...response.data[Object.keys(response.data).find((rs) => rs !== 'cycle')]] : response.data[Object.keys(response.data).find((rs) => rs !== 'cycle')] });
                    },
                )
            }
        }

        formik.setFieldValue(field, data[field])
        setDataFormExist([])
        setDataFormNotExist([])
        setSelected([])
    }

    const formikChangeDate = (val, field, subField, index, type) => {
        let data = JSON.parse(JSON.stringify(formik.values))
        data[field][index] = { ...formik.values[field][index], "ids": [], "condition": formik.values[field][index].condition !== undefined ? { ...formik.values[field][index].condition, [subField]: Util.formatDate(val) } : { [subField]: Util.formatDate(val) } }
        formik.setFieldValue(field, data[field])
    }
    const formikDelete = (dataLoop, field, setData, index) => {
        let data = JSON.parse(JSON.stringify(formik.values))
        let dataShow = JSON.parse(JSON.stringify(dataLoop))
        data[field].splice(index, 1)
        dataShow.splice(index, 1)
        setData(dataShow)
        formik.setFieldValue(field, data[field])
        setDataFormExist([])
        setDataFormNotExist([])
        setSelected([])
    }
    const handleCancel = () => {
        setDiscardDialog(true)
    }

    const [openFailedMessageDialog, setFailedMessageDialog] = React.useState(false);
    const handleOpenFailedMessageDialog = (value) => {
        setFailedMessageDialog(true);
    };
    const handleCloseFailedMessageDialog = (value) => {
        setFailedMessageDialog(false);
    };
    const [discardDialog, setDiscardDialog] = React.useState(false);
    const handleDiscardDialog = (value) => {
        setDiscardDialog(value)
    };
    const handleDiscardChangeConfirm = () => {
        handleDiscardDialog(false)
        openDialog(false);
        navigate('/admin/calibration-session', { replace: false, state: { cycleID: cycleID } });
    };
    const [isSuccessAddDialogOpen, openSuccessAddDialog] = React.useState(false);
    const [isAddDialogOpen, openDialog] = React.useState(false);
    const handleOpenDialog = (value) => {
        openDialog(true);
    };
    const handleDirect = () => {
        openSuccessAddDialog(false)
        navigate('/admin/calibration-session', { replace: false, state: { cycleID: cycleID } });
    }
    const submit = (data) => {
        for (let index = 0; index <= data.criteria.length - 1; index++) {
            data.criteria[index].seq = index + 1
        }
        calibrationService.createCalibrationSession({
            "cycle_id": cycleID,
            "code": data.code,
            "name": data.name,
            "description": "",
            "calibration_template_id": data.formCalibrationTemplete,
            "start_date": formik.values.startDate,
            "end_date": formik.values.endDate,
            "calibration_session_role": {
                "calibrator": data.calibrator,
                "approver": data.approver
            },
            "criteria_calibration": {
                "calibrator_filter": data.filterOne,
                "employee_filter": data.filterTwo,
                "criteria": data.criteria
            },
            "form_evaluate_id": selected,
            "status": "active"
        }).then(
            (response) => {
                openSuccessAddDialog(true)
            },
        ).catch(() => {
            seterrorText(t(`admin.label.calibrationSessionCreatedFail`))
            handleOpenFailedMessageDialog(true)
        })
    }
    const [openPreview, setOpenPreview] = React.useState(false);
    const onOpenPreview = () => {
        setOpenPreview(true)
    }
    const onClosePreview = () => {
        setOpenPreview(false)
    }
    const getListCriteria = () => {
        calibrationService.listDropdown().then(
            (response) => {
                let criteria = []
                for (let index = 0; index <= Object.keys(response.data.criteria).length - 1; index++) {
                    criteria[index] = response.data.criteria[Object.keys(response.data.criteria)[index]]
                }
                setListsType(criteria)
                setFilterOne(response.data.calibrator_filter)
                setFilterTwo(response.data.employee_filter)
            },
        )
    }
    const getListFormCalibrationTemplete = () => {
        calibrationService.listFormCalibrationTemplete(cycleID).then(
            (response) => {
                setFormCalibrationTemplete(response.data.calibration_template)
            },
        )
    }
    const getListDropdownManager = () => {
        calibrationService.listDropdownManager(cycleID).then(
            (response) => {
                // let checkDataCalibrator = response.data.manager.filter((rs) => rs.serial !== formik.values.approver)
                // let checkDataApprover = response.data.manager.filter((rs) => rs.serial !== formik.values.calibrator)
                // if (checkDataCalibrator.length > 0 || checkDataApprover.length > 0) {
                //     setCalibrator(checkDataCalibrator)
                //     setItemsCalibrator(checkDataCalibrator)
                // // } else if (checkDataApprover.length > 0) {
                //     setApprover(checkDataApprover)
                //     setItemsApprover(checkDataApprover)
                // } else {
                setCalibrator(response.data.manager)
                setApprover(response.data.manager)
                setItemsCalibrator(response.data.manager)
                setItemsApprover(response.data.manager)
                // }
            },
        )
    }
    let checkSelectCode = (code, type, selectCode) => {
        if (formik?.values?.criteria !== undefined && formik?.values?.criteria.length > 0) {
            let checkFormit = formik?.values?.criteria.filter((rs) => rs.code === code && rs.type === type && rs.code !== selectCode)
            if (checkFormit.length > 0) {
                return "none";
            }
        }
        return "";
    }

    const onChangeCalibrator = (data) => {
        formik.setFieldValue("calibrator", data)
    }
    const handleValidate = () => {
        // setValidate(true)
        let findDataCriteria = formik.values.criteria.filter((res) => res.code === "" || res.idsDisplay.length < 1)
        let findDataFormCalibrationTemplete = formik.values.formCalibrationTemplete === ""
        if (findDataCriteria !== undefined && findDataCriteria.length > 0) {
            let data = []
            for (let index = 0; index <= formik.values.criteria.length - 1; index++) {
                if (formik.values.criteria[index].code !== "" || formik.values.criteria[index].type !== "") {
                    if (formik.values.criteria[index].code === "" && formik.values.criteria[index].type === "") {

                    } else {
                        data.push(formik.values.criteria[index])
                    }
                }
            }
            setCriteria(data)
            formik.setFieldValue("criteria", data)
        } else if (formik.values.formCalibrationTemplete === "" || formik.values.calibrator === "") {
            formik.submitForm()
        } else if (formik.values.formCalibrationTemplete !== "" && formik.values.calibrator !== "" && findDataCriteria.length === 0) {
            calibrationService.validate({
                cycle_id: cycleID,
                calibrator: formik.values.calibrator,
                // approver: formik.values.approver,
                calibration_template_id: formik.values.formCalibrationTemplete,
                calibrator_filter: formik.values.filterOne,
                employee_filter: formik.values.filterTwo,
                criteria: formik.values.criteria,
            }).then(
                (response) => {
                    setDataFormExist(response?.data?.form_exist)
                    setDataFormNotExist(response?.data?.forn_not_exist)
                },
            ).catch(() => {
                // seterrorText(t(`admin.label.GoalCategoryCreatedFail`))
                // handleOpenFailedMessageDialog(true)
            })
        }
        setOnSubmit(true)
    }
    const [selected, setSelected] = React.useState([]);
    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelecteds = dataFormExist.map((n) => n.serial);
            // const newSelectedsError = dataFormExist.filter((n) => n.serial);
            // console.log(newSelectedsError,22);
            setSelected(newSelecteds);
            return;
        }
        setSelected([]);
    };

    const handleClick = (event, serial) => {
        const selectedIndex = selected.indexOf(serial);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, serial);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }

        setSelected(newSelected);
    };
    const isSelected = (serial) => selected.indexOf(serial) !== -1;
    useEffect(() => {
        setDateWork()
    }, [dataFormNotExist]);
    const [dateEmpoloyee, setDateEmpoloyee] = React.useState("");
    const setDateWork = () => {
        let dataEmpolyeeDate = ''
        for (let index = 0; index <= dataFormNotExist.length - 1; index++) {
            console.log(dataFormNotExist[index]);
            if (Util.formatData(dataFormNotExist[index]?.emp_exp, false) !== false) {
                dataEmpolyeeDate = dataFormNotExist[index]?.emp_exp
                if (language === "en-US") {
                    dataEmpolyeeDate = dataEmpolyeeDate.replace('y', 'y ')
                    dataEmpolyeeDate = dataEmpolyeeDate.replace('m', 'm ')
                    // dataEmpolyeeDate = dataEmpolyeeDate.replace('d', 'd ')
                    // setDateEmpoloyee(dataEmpolyeeDate)
                } else {
                    dataEmpolyeeDate = dataEmpolyeeDate.replace('y', ' ปี ')
                    dataEmpolyeeDate = dataEmpolyeeDate.replace('m', ' เดือน ')
                    dataEmpolyeeDate = dataEmpolyeeDate.replace('d', ' วัน')
                    // setDateEmpoloyee(dataEmpolyeeDate)
                }
            }
            setDateEmpoloyee(dataEmpolyeeDate)
        }
    }

    const showExp = (dataEmpolyeeDate) => {
        if (dataEmpolyeeDate) {
            if (language === "en-US") {
                dataEmpolyeeDate = dataEmpolyeeDate.replace('y', 'y ')
                dataEmpolyeeDate = dataEmpolyeeDate.replace('m', 'm ')
                // dataEmpolyeeDate = dataEmpolyeeDate.replace('d', 'd ')
                // setDateEmpoloyee(dataEmpolyeeDate)
            } else {
                dataEmpolyeeDate = dataEmpolyeeDate.replace('y', ' ปี ')
                dataEmpolyeeDate = dataEmpolyeeDate.replace('m', ' เดือน ')
                dataEmpolyeeDate = dataEmpolyeeDate.replace('d', ' วัน')
                // setDateEmpoloyee(dataEmpolyeeDate)
            }
        }
        return dataEmpolyeeDate
    }

    const [search, setSearchValue] = React.useState("");
    const [itemsCalibrator, setItemsCalibrator] = React.useState([]);
    const handleSearch = (event) => {
        setSearchValue(event.target.value);
    };

    const dataSerachs = async (data) => {
        let result = []
        let dataSerach = JSON.parse(JSON.stringify(calibrator))
        if (data !== "") {
            result = dataSerach.filter((item) => {
                return Object.keys(item).some((key) => {
                    if (key === 'fullname' || key === 'code') {
                        return item[key].toString().toLowerCase().indexOf(data.toString().toLowerCase()) !== -1;
                    }
                });
            });
        } else {
            result = dataSerach;
        }
        await setItemsCalibrator(result)
    };

    const [itemsApprover, setItemsApprover] = React.useState([]);
    // const handleSearchApprover = (event) => {
    //     setSearchValueApprover(event.target.value);
    // };

    const dataSerachsApprover = async (data) => {
        let result = []
        let dataSerach = JSON.parse(JSON.stringify(approver))
        if (data !== "") {
            result = dataSerach.filter((item) => {
                return Object.keys(item).some((key) => {
                    if (key === 'fullname' || key === 'code') {
                        return item[key].toString().toLowerCase().indexOf(data.toString().toLowerCase()) !== -1;
                    }
                });
            });
        } else {
            result = dataSerach;
        }
        console.log(result, 1234);
        await setItemsApprover(result)
    };
    const [focusSearch, openFocusSearch] = React.useState(false);
    const [selectSearch, setSelectSearch] = React.useState([]);
    const [focusSearchApprover, openFocusSearchApprover] = React.useState(false);
    const [selectSearchApprover, setSelectSearchApprover] = React.useState([]);
    const handleClose = (event) => {
        openFocusSearch(false)
        if (Util.formatData(document.getElementById('searchCalibrator'), false) !== false) {
            document.getElementById('searchCalibrator').value = ""
        }
    };

    const handleFocus = () => {
        setSelectSearch([])
        openFocusSearch(true)
    };
    const changeHandler = event => {
        // setQuery(event.target.value);
        dataSerachs(event.target.value,)
    };
    const debouncedChangeHandler = useCallback(
        debounce(changeHandler, 500), console.log()
        , []);

    const onclickSelectCalibrator = (data) => {
        formik.setFieldValue("calibrator", data)
        openFocusSearch(false)
    }
    const handleCloseApprover = (event) => {
        openFocusSearchApprover(false)
        if (Util.formatData(document.getElementById('searchEmployee'), false) !== false) {
            document.getElementById('searchEmployee').value = ""
        }
    };
    const handleFocusApprover = () => {
        setSelectSearchApprover([])
        openFocusSearchApprover(true)
    };
    const changeHandlerApprover = event => {
        // setQuery(event.target.value);
        dataSerachsApprover(event.target.value,)
    };
    const debouncedChangeHandlerApprover = useCallback(
        debounce(changeHandlerApprover, 500), console.log()
        , []);
    const onclickSelectApprover = (data) => {
        formik.setFieldValue("approver", data)
        openFocusSearchApprover(false)
    }
    const handleClearClick = () => {
        formik.setFieldValue("approver", '')
    };
    const [minDate, setMinDate] = React.useState(Util.formatDate(new Date()));
    useEffect(() => {
        const date = new Date(formik.values.startDate);
        date.setDate(date.getDate() + 1);
        setMinDate(date)
    }, [formik.values.startDate])

    const [checkboxError, setCheckboxError] = React.useState(false);
    // const handleSelectError = (serial) => {
    //     let dataFormExistMain = []
    //     for (let index = 0; index <= dataFormExist.length - 1; index++) {
    //         for (let indexs = 0; indexs <= selected.length - 1; indexs++) {
    //             if (dataFormExist[index].serial === selected[indexs]) {
    //                 dataFormExistMain.push(dataFormExist[index])
    //             }
    //         }
    //     }
    //     let data = dataFormExistMain.filter((item) => item.employee.serial === serial)
    //     if (data.length > 1) {
    //         setCheckboxError(true)
    //         return true
    //     }
    //     return false
    // }
    const handleSelectError = (serial) => {
        let data = selected.filter((rs) => {
            let datas = dataFormExist.filter((item) => {
                if (item.serial === rs && item.employee.serial === serial) {
                    return true
                } else {
                    return false
                }
            })
            if (datas.length > 0) {
                return true
            } else {
                return false
            }
        })
        if (data.length > 1) {
            return true
        }
        return false
    }
    const checkErrorCheckbox = () => {
        let dataSerialDuplicate = []
        let dataSerialNotDuplicate = []
        for (let index = 0; index <= selected.length - 1; index++) {
            for (let idx = 0; idx <= dataFormExist.length - 1; idx++) {
                if (dataFormExist[idx].serial === selected[index]) {
                    if (dataSerialNotDuplicate.indexOf(dataFormExist[idx].employee.serial) < 0) {
                        dataSerialNotDuplicate.push(dataFormExist[idx].employee.serial);
                    } else {
                        dataSerialDuplicate.push(dataFormExist[idx].employee.serial);
                    }
                }
            }
        }
        if (dataSerialDuplicate.length > 0) {
            return true
        }
        return false
    }

    return (
        <>
            <Helmet>
                <title>HOME | PMS </title>
            </Helmet>
            <Box
                sx={{
                    backgroundColor: 'background.default',
                    minHeight: '100%',
                    py: 3
                }}
            >
                <Container maxWidth="xl">
                    <Grid container pt={2} pb={2}>
                        <Typography fontSize={16} lineHeight={1} color="#68717A"><span style={styles.link} onClick={() => clickLink('/admin/calibration-session')}>{t('admin.label.calibrationSession')}</span> / <span style={styles.end} >{t('admin.label.createCalibrationSession')}</span></Typography>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={12} >
                            <Typography variant="h1" fontSize={36} lineHeight="53.82px" fontWeight="500" color="#404349">
                                {t('admin.label.createCalibrationSession')}
                            </Typography>
                        </Grid>
                        <Grid direction="column" sx={{}}
                            container item
                            justifyContent="center"
                            alignItems="center">

                            <Grid container item>
                                <Paper sx={{ padding: "40px 40px 20px", "box-shadow": " 0px 2px 10px rgba(0, 0, 0, 0.1)", "border-radius": "10px", width: '100%' }} classes={{ root: classes.error }}>
                                    <Box display="flex" sx={{ margin: "0 -40px", flexFlow: "row wrap" }}>
                                        <Box sx={{ width: "calc(100% - 80px)", margin: "0 40px", position: "relative", ".MuiFormControl-root": { "margin-top": "7px" }, ".MuiFormHelperText-root": { position: "absolute", bottom: "-23px" } }} >
                                            <Typography variant="subtitle1" fontWeight="500" fontSize={18} lineHeight="26.91px" display="flex">{t('admin.inputForm.code')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                                            <TextField
                                                error={Boolean(formik.touched.code && formik.errors.code) === false ? checkCode === true ? true : false : true}
                                                fullWidth
                                                helperText={formik.touched.code && formik.errors.code}
                                                margin="normal"
                                                name="code"
                                                onBlur={formik.handleBlur}
                                                onChange={formik.handleChange}
                                                type="text"
                                                value={formik.values.code}
                                                variant="outlined"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                placeholder={t('admin.inputForm.placeholder.code')}
                                                classes={{ root: classes.input }}
                                            />
                                            {Boolean(formik.touched.code && formik.errors.code) === false && checkCode === true ? (<FormHelperText error sx={{ marginTop: "-5px", marginRight: "14px", marginBottom: "8px", marginLeft: "14px" }}>{t('label.alreadyUsed')} </FormHelperText>) : <></>}
                                        </Box>
                                        <Box pt="17px" sx={{ width: "calc(100% - 80px)", margin: "0 40px", ".MuiFormControl-root": { "margin-top": "7px" }, ".MuiFormHelperText-root": { position: "absolute", bottom: "-23px" } }}>
                                            <Typography variant="subtitle1" fontWeight="500" fontSize={18} lineHeight="26.91px" display="flex">{t('admin.inputForm.name')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                                            <TextField
                                                error={Boolean(formik.touched.name && formik.errors.name)}
                                                fullWidth
                                                helperText={formik.touched.name && formik.errors.name}
                                                margin="normal"
                                                name="name"
                                                onBlur={formik.handleBlur}
                                                onChange={formik.handleChange}
                                                type="text"
                                                value={formik.values.name}
                                                variant="outlined"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                placeholder={t('admin.inputForm.placeholder.name')}
                                                classes={{ root: classes.input }}
                                            />
                                        </Box>
                                        <Box pt="17px" sx={{ width: "calc(100% - 80px)", margin: "0 40px", ".MuiFormControl-root": { "margin-top": "7px" } }}>
                                            <Typography mb="10px" variant="subtitle1" fontWeight="500" fontSize={18} lineHeight="26.91px" display="flex">{t('admin.inputForm.formCalibrationTemplete')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                                            <Select
                                                id="workload-select"
                                                inputlabelprops={{ shrink: false }}
                                                variant="outlined"
                                                size="small"
                                                className="white-bg"
                                                value={formik.values.formCalibrationTemplete}
                                                onBlur={formik.handleBlur}
                                                onChange={formik.handleChange}
                                                defaultValue=""
                                                displayEmpty
                                                placeholder={t('admin.inputForm.placeholder.formCalibrationTemplete')}
                                                error={Boolean(formik.touched.formCalibrationTemplete && formik.errors.formCalibrationTemplete)}
                                                fullWidth
                                                helperText={formik.touched.formCalibrationTemplete && formik.errors.formCalibrationTemplete}
                                                name="formCalibrationTemplete"
                                                classes={classes.select}
                                            >
                                                <MenuItem disabled value="" key="0">
                                                    <Typography variant="sub_label" style={{ fontWeight: "300" }}>{t("admin.inputForm.placeholder.formCalibrationTemplete")} </Typography>
                                                </MenuItem>
                                                {
                                                    formCalibrationTemplete?.length > 0 ?
                                                        formCalibrationTemplete.map(item => {
                                                            return (
                                                                <MenuItem value={item.serial} key={item.serial}>
                                                                    <Typography style={{ fontWeight: "400", fontSize: "16px", fontHeight: "16px", color: '#404349' }}>{item.name}</Typography>
                                                                </MenuItem>
                                                            )
                                                        })
                                                        : <MenuItem value="">
                                                            ไม่พบข้อมูล
                                                        </MenuItem>
                                                }
                                            </Select>
                                            {formik.touched.formCalibrationTemplete && formik.errors.formCalibrationTemplete ? (<FormHelperText error sx={{ marginTop: "4px", marginRight: "14px", marginBottom: 0, marginLeft: "14px" }}>{formik.errors.formCalibrationTemplete} </FormHelperText>) : <></>}
                                        </Box>
                                        <Box pt="17px" sx={{ width: "calc(100% - 80px)", margin: "0 40px", ".MuiFormControl-root": { "margin-top": "7px" }, display: "flex", "flex-flow": "row wrap" }}>
                                            <Box pt="12px" mr="25px" sx={{ width: "calc(50% - 40px)", ".MuiButtonBase-root": { "justify-content": "flex-end", position: "absolute", width: "100%", height: "100%", left: "0", "border-radius": "unset" }, ".MuiFormControl-root": { "margin-top": "7px" }, '& div > div > input': { height: '7px', }, position: "relative" }} >
                                                <Typography fontSize={16} lineHeight="23.96px" color="#404349" fontWeight="500" sx={{ position: "absolute", bottom: "8px", right: "-45px", }}>
                                                    -
                                                </Typography>
                                                <Typography variant="subtitle1" color="#404349" fontWeight="500" fontSize={18} lineHeight="26.91px" display="flex">{t('admin.inputForm.startDate')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                                                <LocalizationProvider dateAdapter={AdapterDateFns} >
                                                    <DatePicker
                                                        components={{
                                                            OpenPickerIcon: Calendar
                                                        }}
                                                        format="dd/MM/yyyy"

                                                        value={formik.values.startDate}
                                                        onChange={(newValue) => {
                                                            selectDate("startDate", newValue);
                                                        }}
                                                        // minDate={item.validator.min_date !== undefined && item.validator.min_date !== null && item.validator.min_date !== "" ? formik.values[item.validator.min_date] !== undefined && formik.values[item.validator.min_date] !== null && formik.values[item.validator.min_date] !== "" ? new Date(formik.values[item.validator.min_date]) : null : null}
                                                        // maxDate={item.validator.max_date !== undefined && item.validator.max_date !== null && item.validator.max_date !== "" ? formik.values[item.validator.max_date] !== undefined && formik.values[item.validator.max_date] !== null && formik.values[item.validator.max_date] !== "" ? new Date(formik.values[item.validator.max_date]) : null : null}
                                                        inputProps={{ placeholder: t('admin.inputForm.placeholder.selectDate'), readOnly: true }}
                                                        renderInput={(params) => <TextField {...params}
                                                            fullWidth
                                                            sx={{
                                                                ".MuiOutlinedInput-root": { color: "#404349", },
                                                                ".MuiOutlinedInput-notchedOutline": formik.touched.startDate && formik.errors.startDate ? { borderColor: "#d32f2f !important" } : "",
                                                            }}
                                                        />
                                                        }
                                                    />
                                                </LocalizationProvider>
                                                {formik.touched.startDate && formik.errors.startDate ? (<FormHelperText error sx={{ marginTop: "4px", marginRight: "14px", marginBottom: 0, marginLeft: "14px" }}>{formik.errors.startDate} </FormHelperText>) : <></>}
                                            </Box>
                                            <Box pt="12px" ml="53px" sx={{ width: "calc(50% - 40px)", ".MuiButtonBase-root": { "justify-content": "flex-end", position: "absolute", width: "100%", height: "100%", left: "0", "border-radius": "unset" }, ".MuiFormControl-root": { "margin-top": "7px" }, '& div > div > input': { height: '7px', } }}>
                                                <Typography variant="subtitle1" color="#404349" fontWeight="500" fontSize={18} lineHeight="26.91px" display="flex">{t('admin.inputForm.endDate')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                                                <LocalizationProvider dateAdapter={AdapterDateFns} >
                                                    <DatePicker
                                                        components={{
                                                            OpenPickerIcon: Calendar
                                                        }}
                                                        format="dd/MM/yyyy"

                                                        value={formik.values.endDate}
                                                        onChange={(newValue) => {
                                                            selectDate("endDate", newValue);
                                                        }}
                                                        minDate={formik.values.startDate !== undefined && formik.values.startDate !== null && formik.values.startDate !== "" ? minDate : null}
                                                        inputProps={{ placeholder: t('admin.inputForm.placeholder.selectDate'), readOnly: true }}
                                                        renderInput={(params) => <TextField {...params}
                                                            fullWidth
                                                            sx={{
                                                                ".MuiOutlinedInput-root": { color: "#404349", },
                                                                ".MuiOutlinedInput-notchedOutline": formik.touched.endDate && formik.errors.endDate ? { borderColor: "#d32f2f !important" } : "",
                                                            }}
                                                        />
                                                        }
                                                    />
                                                </LocalizationProvider>
                                                {formik.touched.endDate && formik.errors.endDate ? (<FormHelperText error sx={{ marginTop: "4px", marginRight: "14px", marginBottom: 0, marginLeft: "14px" }}>{formik.errors.endDate} </FormHelperText>) : <></>}
                                            </Box>
                                        </Box>
                                        <Box sx={{ width: "100%", display: "flex", "flex-flow": "row wrap" }}>
                                            <Box pt="17px" sx={{ width: "calc(50% - 80px)", ".MuiFormControl-root": { marginTop: "7px" }, ".Mui-disabled": { "& fieldset": { borderColor: "#CED4DA" }, background: "#F3F3F3", WebkitTextFillColor: "#AAAAAA !important" }, margin: "0 40px" }}>
                                                <Typography mb="10px" variant="subtitle1" color="#404349" fontWeight="500" fontSize={18} lineHeight="26.91px" display="flex">{t('admin.inputForm.calibrator')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                                                <ClickAwayListener onClickAway={handleClose} >
                                                    <Box sx={{ position: "relative" }}>
                                                        <Box sx={{ position: "relative", "::after": { width: "100%", content: '""', height: " 100%", position: "absolute", left: 0, top: 0, } }} onClick={e => handleFocus(true)} >
                                                            <Select
                                                                id="workload-select"
                                                                inputlabelprops={{ shrink: false }}
                                                                variant="outlined"
                                                                size="small"
                                                                className="white-bg"
                                                                value={formik.values.calibrator}
                                                                onBlur={formik.handleBlur}
                                                                onChange={formik.handleChange}
                                                                defaultValue=""
                                                                displayEmpty
                                                                placeholder={t('admin.inputForm.placeholder.calibrator')}
                                                                error={Boolean(formik.touched.calibrator && formik.errors.calibrator)}
                                                                fullWidth
                                                                helperText={formik.touched.calibrator && formik.errors.calibrator}
                                                                name="calibrator"
                                                                classes={classes.select}
                                                            >
                                                                <MenuItem disabled value="">
                                                                    <Typography variant="sub_label" style={{ fontWeight: "300", color: "#AAAAAA" }}>{t('admin.inputForm.placeholder.calibrator')}</Typography>
                                                                </MenuItem>
                                                                {
                                                                    calibrator?.length > 0 ?
                                                                        calibrator.map(item => {
                                                                            return (
                                                                                <MenuItem value={item.serial} key={item.serial}>
                                                                                    {item.fullname}
                                                                                </MenuItem>
                                                                            )
                                                                        })

                                                                        : <MenuItem value="">
                                                                            ---{t('label.notFund')}---
                                                                        </MenuItem>
                                                                }
                                                            </Select>
                                                        </Box>
                                                        <Box sx={{ position: "absolute", width: "100%", zIndex: "9" }}>
                                                            <Collapse in={focusSearch}>
                                                                <Box sx={{ width: "100%", border: "1px solid #CED4DA", background: "#FFFFFF", boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)", borderRadius: "8px" }} p="15px">
                                                                    <TextField
                                                                        id="searchCalibrator"
                                                                        fullWidth
                                                                        placeholder="Search Calibrator"
                                                                        size="small"
                                                                        // onFocus={e => handleFocus(true)}
                                                                        sx={{ background: "#fff", "input": { padding: "9px 14px" } }}
                                                                        className="searchTextField-h40"
                                                                        autoComplete='off'
                                                                        onChange={debouncedChangeHandler}
                                                                        InputProps={{
                                                                            startAdornment: (
                                                                                <InputAdornment position="start">
                                                                                    <Search style={{ color: "#C4C4C4" }} />
                                                                                </InputAdornment>
                                                                            ),
                                                                        }}
                                                                    />
                                                                    <Box mt="15px" sx={{ maxHeight: "270px", overflowY: "overlay", }} >
                                                                        {itemsCalibrator.length > 0 ? itemsCalibrator.map((rs, index) => (
                                                                            <Box sx={{ display: rs?.serial === formik.values.approver ? "none" : "flex", alignItems: "center", width: "100%", background: rs?.serial === formik.values.calibrator ? "rgba(93, 161, 150, 0.08)" : "", "&:hover": { "background-color": "rgba(0, 0, 0, 0.04)" }, cursor: "pointer" }} p="8px" onClick={e => onclickSelectCalibrator(rs?.serial)} >
                                                                                {/* 15.77+20.84+22.49+20.49+20.41 */}
                                                                                <Box sx={{ display: "flex", flexDirection: "row", width: "20%" }} pr="20px">
                                                                                    <Typography fontSize={18} width="100%" lineHeight="26.91px" color="#404349" fontWeight="400" sx={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", }}>
                                                                                        {rs?.code}
                                                                                    </Typography>
                                                                                </Box>
                                                                                <Box sx={{ display: "flex", flexDirection: "row", width: "40%" }} pr="20px">
                                                                                    <Typography fontSize={18} width="100%" lineHeight="26.91px" color="#404349" fontWeight="400" sx={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", }}>
                                                                                        {Util.formatData(rs?.fullname, "")}
                                                                                    </Typography>
                                                                                </Box>
                                                                                <Box sx={{ display: "flex", flexDirection: "row", width: "40%" }} pr="20px">
                                                                                    <Typography fontSize={18} width="100%" lineHeight="26.91px" color="#404349" fontWeight="400" sx={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", }}>
                                                                                        {rs?.position}
                                                                                    </Typography>
                                                                                </Box>
                                                                            </Box>
                                                                        ))
                                                                            :
                                                                            <Box sx={{ paddingTop: "10px", textAlign: "center" }}>
                                                                                <Typography color="#A0A0A0" fontWeight="500" fontSize={20} lineHeight="30px" >
                                                                                    No data found
                                                                                </Typography>
                                                                            </Box>
                                                                        }
                                                                    </Box>
                                                                </Box>
                                                            </Collapse>
                                                        </Box>
                                                    </Box>
                                                </ClickAwayListener>
                                                {formik.touched.calibrator && formik.errors.calibrator ? (<FormHelperText error sx={{ marginTop: "4px", marginRight: "14px", marginBottom: 0, marginLeft: "14px" }}>{formik.errors.calibrator} </FormHelperText>) : <></>}
                                            </Box>
                                            <Box pt="17px" sx={{ width: "calc(50% - 80px)", ".MuiFormControl-root": { marginTop: "7px" }, ".Mui-disabled": { "& fieldset": { borderColor: "#CED4DA" }, background: "#F3F3F3", WebkitTextFillColor: "#AAAAAA !important" }, margin: "0 40px" }}>
                                                <Typography mb="10px" variant="subtitle1" color="#404349" fontWeight="500" fontSize={18} lineHeight="26.91px" display="flex">{t('admin.inputForm.approver')}</Typography>
                                                <ClickAwayListener onClickAway={handleCloseApprover} >
                                                    <Box sx={{ position: "relative" }}>
                                                        <Box sx={{ position: "relative", "::after": { width: "100%", content: '""', height: " 100%", position: "absolute", left: 0, top: 0, } }} onClick={e => handleFocusApprover(true)} >
                                                            <Select
                                                                id="workload-select"
                                                                inputlabelprops={{ shrink: false }}
                                                                variant="outlined"
                                                                size="small"
                                                                className="white-bg"
                                                                value={formik.values.approver}
                                                                onBlur={formik.handleBlur}
                                                                onChange={formik.handleChange}
                                                                defaultValue=""
                                                                displayEmpty
                                                                placeholder={t('admin.inputForm.placeholder.approver')}
                                                                // error={Boolean(formik.touched.approver && formik.errors.approver)}
                                                                fullWidth
                                                                // helperText={formik.touched.approver && formik.errors.approver}
                                                                name="approver"
                                                                classes={classes.select}
                                                                sx={{ "& .MuiSelect-iconOutlined": { display: formik.values.approver ? 'none' : '' }, "&.Mui-focused .MuiIconButton-root": { color: 'primary' } }}
                                                                endAdornment={<IconButton sx={{ visibility: formik.values.approver ? "visible" : "hidden", zIndex: 2, padding: "5px", marginRight: "-5px" }} onClick={handleClearClick}><ClearIcon style={{ width: "15px", height: "15px" }} /></IconButton>}
                                                            >
                                                                <MenuItem disabled value="">
                                                                    <Typography variant="sub_label" style={{ fontWeight: "300", color: "#AAAAAA" }}>{t('admin.inputForm.placeholder.approver')}</Typography>
                                                                </MenuItem>
                                                                {
                                                                    approver?.length > 0 ?
                                                                        approver.map(item => {
                                                                            return (
                                                                                <MenuItem value={item.serial} key={item.serial}>
                                                                                    {item.fullname}
                                                                                </MenuItem>
                                                                            )
                                                                        })

                                                                        : <MenuItem value="">
                                                                            ---{t('label.notFund')}---
                                                                        </MenuItem>
                                                                }
                                                            </Select>
                                                        </Box>
                                                        <Box sx={{ position: "absolute", width: "100%", zIndex: "9" }}>
                                                            <Collapse in={focusSearchApprover}>
                                                                <Box sx={{ width: "100%", border: "1px solid #CED4DA", background: "#FFFFFF", boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)", borderRadius: "8px" }} p="15px">
                                                                    <TextField
                                                                        id="searchEmployee"
                                                                        fullWidth
                                                                        placeholder="Search employee"
                                                                        size="small"
                                                                        sx={{ background: "#fff", "input": { padding: "9px 14px" } }}
                                                                        className="searchTextField-h40"
                                                                        autoComplete='off'
                                                                        onChange={debouncedChangeHandlerApprover}
                                                                        InputProps={{
                                                                            startAdornment: (
                                                                                <InputAdornment position="start">
                                                                                    <Search style={{ color: "#C4C4C4" }} />
                                                                                </InputAdornment>
                                                                            ),
                                                                        }}
                                                                    />
                                                                    <Box mt="15px" sx={{ maxHeight: "270px", overflowY: "overlay", }} >
                                                                        {itemsApprover.length > 0 ? itemsApprover.map((rs, index) => (
                                                                            <Box sx={{ display: rs?.serial === formik.values.calibrator ? "none" : "flex", alignItems: "center", width: "100%", background: rs?.serial === formik.values.approver ? "rgba(93, 161, 150, 0.08)" : "", "&:hover": { "background-color": "rgba(0, 0, 0, 0.04)" }, cursor: "pointer" }} p="8px" onClick={e => onclickSelectApprover(rs?.serial)} >
                                                                                <Box sx={{ display: "flex", flexDirection: "row", width: "20%" }} pr="20px">
                                                                                    <Typography fontSize={18} width="100%" lineHeight="26.91px" color="#404349" fontWeight="400" sx={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", }}>
                                                                                        {rs?.code}
                                                                                    </Typography>
                                                                                </Box>
                                                                                <Box sx={{ display: "flex", flexDirection: "row", width: "40%" }} pr="20px">
                                                                                    <Typography fontSize={18} width="100%" lineHeight="26.91px" color="#404349" fontWeight="400" sx={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", }}>
                                                                                        {Util.formatData(rs?.fullname, "")}
                                                                                    </Typography>
                                                                                </Box>
                                                                                <Box sx={{ display: "flex", flexDirection: "row", width: "40%" }} pr="20px">
                                                                                    <Typography fontSize={18} width="100%" lineHeight="26.91px" color="#404349" fontWeight="400" sx={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", }}>
                                                                                        {rs?.position}
                                                                                    </Typography>
                                                                                </Box>
                                                                            </Box>
                                                                        ))
                                                                            :
                                                                            <Box sx={{ paddingTop: "10px", textAlign: "center" }}>
                                                                                <Typography color="#A0A0A0" fontWeight="500" fontSize={20} lineHeight="30px" >
                                                                                    No data found
                                                                                </Typography>
                                                                            </Box>
                                                                        }
                                                                    </Box>
                                                                </Box>
                                                            </Collapse>
                                                        </Box>
                                                    </Box>
                                                </ClickAwayListener>
                                                {/* {formik.touched.approver && formik.errors.approver ? (<FormHelperText error sx={{ marginTop: "4px", marginRight: "14px", marginBottom: 0, marginLeft: "14px" }}>{formik.errors.approver} </FormHelperText>) : <></>} */}
                                            </Box>
                                        </Box>
                                        <Box pt="17px" sx={{ width: "calc(100% - 80px)", margin: "0 40px" }}>
                                            <Box display="flex" justifyContent="space-between" alignItems="center">
                                                <Typography variant="subtitle1" fontWeight="500" fontSize={18} lineHeight="26.91px" display="flex">{t('admin.label.distributionGuideline')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                                            </Box>
                                            <Box sx={{ position: "relative" }}>
                                                <Box mt="10px" sx={{ border: onSubmit === true ? criteria.length === 0 ? "1px solid #CC6058" : "1px solid #CED4DA" : "1px solid #CED4DA", "box-sizing": "border-box", "border-radius": "4px", padding: "17px 29px" }}>
                                                    <Box sx={{ display: "flex", "align-items": "center", "justify-content": "space-between" }} mb="15px">
                                                        <Typography fontWeight="500" color="#404349" fontSize={16} lineHeight="23.92px" display="flex" sx={{ textTransform: "uppercase" }}>{t('admin.inputForm.ManageCriteria')}</Typography>
                                                        <Box onClick={addCriteria} sx={{ cursor: "pointer", width: "max-content", display: "flex", "flex-direction": "row", "justify-content": "center", "align-items": "center", padding: "4px 10px", "border-radius": "4px", }}>
                                                            <PlusIcon />
                                                            <Typography pl="5px" fontWeight="500" color="#5DA196" fontSize={18} lineHeight="26.91px" display="flex">{t('label.add')}</Typography>
                                                        </Box>
                                                    </Box>
                                                    <Divider />
                                                    <Box sx={{ overflow: "hidden", height: "100%", transition: "all .8s", "max-height": criteria !== undefined && criteria !== null && criteria.length > 0 ? "999999px" : "0px" }}>
                                                        {criteria !== undefined && criteria !== null && criteria.length > 0 ?
                                                            <Box pb="16px">
                                                                <Box sx={{ width: "100%", padding: "15px", display: "flex", "align-items": "center", flexFlow: "row wrap" }}>
                                                                    <Typography sx={{ width: "81px" }} mr="30px" style={{ fontWeight: "500", fontSize: "16px", lineHeight: "23.92px", color: '#404349', display: "flex" }}>Filter By<Box fontStyle="italic" sx={{ fontWeight: 200, margin: "0 5px", color: "#CC6058 " }}> *</Box>:</Typography>
                                                                    <Box sx={{ width: "calc(50% - 81px)" }}>
                                                                        <Select
                                                                            id="workload-select"
                                                                            inputlabelprops={{ shrink: false }}
                                                                            variant="outlined"
                                                                            size="small"
                                                                            className="white-bg"
                                                                            value={formik.values.filterOne}
                                                                            onBlur={formik.handleBlur}
                                                                            onChange={formik.handleChange}
                                                                            defaultValue=""
                                                                            displayEmpty
                                                                            placeholder={t('admin.inputForm.placeholder.formCalibrationTemplete')}
                                                                            error={Boolean(formik.touched.filterOne && formik.errors.filterOne)}
                                                                            fullWidth
                                                                            helperText={formik.touched.filterOne && formik.errors.filterOne}
                                                                            name="filterOne"
                                                                            classes={classes.select}
                                                                        >
                                                                            {/* <MenuItem disabled value="" key="0">
                                                                                <Typography variant="sub_label" style={{ fontWeight: "300" }}>{t("admin.inputForm.placeholder.formCalibrationTemplete")} </Typography>
                                                                            </MenuItem> */}
                                                                            {
                                                                                filterOne?.length > 0 ?
                                                                                    filterOne.map(item => {
                                                                                        return (
                                                                                            <MenuItem value={item} key={item}>
                                                                                                <Typography style={{ fontWeight: "400", fontSize: "16px", fontHeight: "16px", color: '#404349' }}>
                                                                                                    {item === "all" ?
                                                                                                        "All Employees"
                                                                                                        : item === "direct_one_level_down" ?
                                                                                                            "Calibrator’s direct 1 level down"
                                                                                                            : item === "direct_all_level_down" ?
                                                                                                                "Calibrator’s direct all level down"
                                                                                                                : "All"
                                                                                                    }
                                                                                                </Typography>
                                                                                            </MenuItem>
                                                                                        )
                                                                                    })
                                                                                    : <MenuItem value="">
                                                                                        ไม่พบข้อมูล
                                                                                    </MenuItem>
                                                                            }
                                                                        </Select>
                                                                    </Box>
                                                                    <Box ml="40px" sx={{ width: "calc(50% - 81px)" }}>
                                                                        <Select
                                                                            id="workload-select"
                                                                            inputlabelprops={{ shrink: false }}
                                                                            variant="outlined"
                                                                            size="small"
                                                                            className="white-bg"
                                                                            value={formik.values.filterTwo}
                                                                            onBlur={formik.handleBlur}
                                                                            onChange={formik.handleChange}
                                                                            defaultValue=""
                                                                            displayEmpty
                                                                            placeholder={t('admin.inputForm.placeholder.formCalibrationTemplete')}
                                                                            error={Boolean(formik.touched.filterTwo && formik.errors.filterTwo)}
                                                                            fullWidth
                                                                            helperText={formik.touched.formCalibrationTemplete && formik.errors.filterTwo}
                                                                            name="filterTwo"
                                                                            classes={classes.select}
                                                                        >
                                                                            {/* <MenuItem disabled value="" key="0">
                                                                                <Typography variant="sub_label" style={{ fontWeight: "300" }}>{t("admin.inputForm.placeholder.formCalibrationTemplete")} </Typography>
                                                                            </MenuItem> */}
                                                                            {
                                                                                filterTwo?.length > 0 ?
                                                                                    filterTwo.map(item => {
                                                                                        return (
                                                                                            <MenuItem value={item} key={item}>
                                                                                                <Typography style={{ fontWeight: "400", fontSize: "16px", fontHeight: "16px", color: '#404349' }}>
                                                                                                    {item === "all" ?
                                                                                                        "All"
                                                                                                        : item === "with_direct_report" ?
                                                                                                            "With subordinate report"
                                                                                                            : item === "without_direct_report" ?
                                                                                                                "Without subordinate report"
                                                                                                                : "All"
                                                                                                    }
                                                                                                </Typography>
                                                                                            </MenuItem>
                                                                                        )
                                                                                    })
                                                                                    : <MenuItem value="">
                                                                                        ไม่พบข้อมูล
                                                                                    </MenuItem>
                                                                            }
                                                                        </Select>
                                                                    </Box>
                                                                </Box>
                                                                <Divider />
                                                                {criteria.map((item, index) => (
                                                                    <Box sx={{ width: "100%" }} >
                                                                        <Box sx={{ height: "100%", padding: "15px", display: "flex", "align-items": "center", flexFlow: "row wrap" }}>
                                                                            <Box sx={{ width: "81px" }} mr="30px">
                                                                                <Typography style={{ fontWeight: "500", fontSize: "16px", lineHeight: "23.92px", color: '#AAAAAA', textTransform: "uppercase", display: "flex" }}>Include <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                                                                                {/* <Select
                                                                                    // id={`${item.key}`}
                                                                                    variant="outlined"
                                                                                    defaultValue=""
                                                                                    displayEmpty
                                                                                    size="small"
                                                                                    placeholder={t('admin.inputForm.placeholder.selectAnswerType')}
                                                                                    fullWidth
                                                                                    // disabled={item.edit === false ? true : false}selectError
                                                                                    className="white-bg"
                                                                                    onChange={e => formikChange(e, "criteria", "type", index, "select")}
                                                                                    value={formik.values.criteria[index].type}
                                                                                    classes={onSubmit === true ? formik.values.criteria[index].type === "" ? { root: classes.selectError } : { root: classes.select } : { root: classes.select }}
                                                                                >
                                                                                    <MenuItem disabled value="" key="0">
                                                                                        <Typography variant="sub_label" style={{ fontWeight: "300" }}>{t("admin.inputForm.placeholder.selectAnswerType")} </Typography>
                                                                                    </MenuItem>
                                                                                    <MenuItem value="include" key="1" >
                                                                                        <Typography style={{ fontWeight: "400", fontSize: "16px", fontHeight: "16px", color: '#404349' }}>Include</Typography>
                                                                                    </MenuItem>
                                                                                    <MenuItem value="exclude" key="2" >
                                                                                        <Typography style={{ fontWeight: "400", fontSize: "16px", fontHeight: "16px", color: '#404349' }}>Exclude</Typography>
                                                                                    </MenuItem>
                                                                                </Select> */}
                                                                            </Box>
                                                                            <Box sx={{ width: "calc(100% - 171px)" }} pr="30px">
                                                                                <Select
                                                                                    // id={`${item.key}`}
                                                                                    variant="outlined"
                                                                                    defaultValue=""
                                                                                    displayEmpty
                                                                                    size="small"
                                                                                    placeholder={t('admin.inputForm.placeholder.selectCriteria')}
                                                                                    fullWidth
                                                                                    // disabled={item.edit === false ? true : false}selectError
                                                                                    className="white-bg"
                                                                                    onChange={e => formikChange(e, "criteria", "code", index, "select")}
                                                                                    value={formik.values.criteria[index].code}
                                                                                    // classes={{ root: classes.select }}
                                                                                    classes={onSubmit === true ? formik.values.criteria[index].code === "" ? { root: classes.selectError } : { root: classes.select } : { root: classes.select }}
                                                                                // onChange={selectField(`${item.key}`)}
                                                                                // sx={Boolean(formik.touched[item.key] && formik.errors[item.key]) ? { border: "0.5px solid red", marginTop: "10px", marginBottom: 0 } : { marginTop: "10px", marginBottom: 0 }}
                                                                                >
                                                                                    <MenuItem disabled value="" key="0">
                                                                                        <Typography variant="sub_label" style={{ fontWeight: "300" }}>{t("admin.inputForm.placeholder.selectCriteria")} </Typography>
                                                                                    </MenuItem>
                                                                                    {
                                                                                        listsType?.length > 0 ?
                                                                                            listsType.map(item => {
                                                                                                return (
                                                                                                    <MenuItem value={item.code} key={item.code} sx={{ display: checkSelectCode(item.code, formik.values.criteria[index].type, formik.values.criteria[index].code) }}>
                                                                                                        <Typography style={{ fontWeight: "400", fontSize: "16px", fontHeight: "16px", color: '#404349' }}>{item.name}</Typography>
                                                                                                    </MenuItem>
                                                                                                )
                                                                                            })
                                                                                            : <MenuItem value="">
                                                                                                ไม่พบข้อมูล
                                                                                            </MenuItem>
                                                                                    }
                                                                                </Select>
                                                                            </Box>
                                                                            {criteria.length === 1 ?
                                                                                <Box sx={{ width: "60px", "padding-left": "10px", height: "20px" }}>
                                                                                    <Delete style={{ cursor: "default" }} className={classes.fillGrey} />
                                                                                </Box>
                                                                                :
                                                                                <Box sx={{ width: "60px", "padding-left": "10px", height: "20px" }}>
                                                                                    <Delete style={{ cursor: "pointer" }} onClick={e => formikDelete(criteria, "criteria", setCriteria, index)} />
                                                                                </Box>
                                                                            }
                                                                            {formik.values.criteria[index].code !== undefined && formik.values.criteria[index].code !== "" ?
                                                                                valueSubCriteria[formik?.values?.criteria[index]?.code] !== undefined ?
                                                                                    <Box display="flex" alignItems="center" sx={{ width: "100%", flexFlow: "row wrap" }} mt="20px">
                                                                                        <Box sx={{ '.MuiOutlinedInput-notchedOutline': { "border-color": onSubmit === true ? formik.values.criteria[index].idsDisplay !== "" && formik.values.criteria[index].idsDisplay !== undefined && formik.values.criteria[index].idsDisplay !== null && formik.values.criteria[index].idsDisplay.length > 0 ? "" : "#CC6058" : "" }, minWidth: "calc(30% - 30px)" }} mr="30px" >
                                                                                            <Autocomplete
                                                                                                multiple
                                                                                                id="checkboxes-tags-demo"
                                                                                                size="small"
                                                                                                fullWidth
                                                                                                options={valueSubCriteria[formik?.values?.criteria[index]?.code]}
                                                                                                disableCloseOnSelect
                                                                                                value={formik.values.criteria[index]?.idsDisplay}
                                                                                                onChange={(event, newValue) => {
                                                                                                    formikChangeOrganization(newValue, "criteria", "ids", index, valueSubCriteria[formik?.values?.criteria[index]?.code])
                                                                                                }}
                                                                                                classes={onSubmit === true ? formik.values.criteria[index].idsDisplay === "" ? { root: classes.selectError, root: classes.styleTag } : { root: classes.select, root: classes.styleTag } : { root: classes.select, root: classes.styleTag }}
                                                                                                getOptionLabel={(option) => option?.code + ' - ' + option?.name}
                                                                                                renderOption={(props, option, { selected }) => (
                                                                                                    <li {...props}>
                                                                                                        {option?.value === undefined ? <Checkbox
                                                                                                            icon={icon}
                                                                                                            checkedIcon={checkedIcon}
                                                                                                            style={{ marginRight: 8 }}
                                                                                                            checked={option?.value === undefined ? selected : valueSubCriteria[formik?.values?.criteria[index]?.code].length - 1 === formik.values.criteria[index]?.idsDisplay.length}
                                                                                                        /> :
                                                                                                            <Checkbox
                                                                                                                icon={icon}
                                                                                                                checkedIcon={checkedIcon}
                                                                                                                style={{ marginRight: 8 }}
                                                                                                                indeterminate={valueSubCriteria[formik?.values?.criteria[index]?.code].length - 1 !== formik.values.criteria[index]?.idsDisplay.length && formik.values.criteria[index]?.idsDisplay.length > 0}
                                                                                                                checked={option?.value === undefined ? selected : valueSubCriteria[formik?.values?.criteria[index]?.code].length - 1 === formik.values.criteria[index]?.idsDisplay.length}
                                                                                                            />}

                                                                                                        {option?.value === undefined ? `${option?.code} - ${option?.name}` : option?.label}
                                                                                                    </li>
                                                                                                )}
                                                                                                style={{ width: "100%" }}
                                                                                                renderInput={(params) => (
                                                                                                    <TextField
                                                                                                        {...params}
                                                                                                        // defaultValue=""
                                                                                                        // displayEmpty
                                                                                                        // placeholder={formik.values.criteria[index]?.idsDisplay !== undefined && formik.values.criteria[index]?.idsDisplay !== null && formik.values.criteria[index]?.idsDisplay !== "" ? "" : `Select ${formik.values.criteria[index].code}` }
                                                                                                        placeholder={`Select`}
                                                                                                        InputLabelProps={{
                                                                                                            ...params.inputProps,
                                                                                                            shrink: true,
                                                                                                        }}
                                                                                                    />
                                                                                                )}
                                                                                            />
                                                                                            {onSubmit === true ? formik.values.criteria[index].idsDisplay !== "" && formik.values.criteria[index].idsDisplay !== undefined && formik.values.criteria[index].idsDisplay !== null && formik.values.criteria[index].idsDisplay.length > 0 ? <></> : (<FormHelperText error sx={{ marginTop: "4px", marginRight: "14px", marginBottom: 0, marginLeft: "14px" }}>{t('admin.inputForm.msgError.code')}</FormHelperText>) : <></>}
                                                                                        </Box>
                                                                                        {formik.values.criteria[index].code === "organization" ?
                                                                                            <Box item display="flex" alignItems="center">
                                                                                                <Checkbox color="primary" sx={{ pl: 0 }} onClick={e => onCheckboxChange(e, "criteria", "include_sub_organization", index, "checkbox")} checked={formik.values.criteria[index]?.condition?.include_sub_organization} />
                                                                                                <Typography variant="subtitle1" fontSize={16} lineHeight="23.92px" fontWeight={500}>Include Sub-Organization</Typography>
                                                                                            </Box>
                                                                                            : null
                                                                                        }
                                                                                    </Box>
                                                                                    :
                                                                                    null
                                                                                : null
                                                                            }
                                                                        </Box>
                                                                        <Divider />
                                                                    </Box>
                                                                ))
                                                                }
                                                            </Box>
                                                            :
                                                            null
                                                        }
                                                    </Box>
                                                    <Box mt="5px">
                                                        <Box display="flex" flexDirection="row-reverse">
                                                            <Box sx={{ width: "100px" }}>
                                                                <Button onClick={e => handleValidate()} color="primary" variant="contained" fullWidth sx={{ textTransform: "none", }}>
                                                                    {t('label.validate')}
                                                                </Button>
                                                            </Box>
                                                        </Box>
                                                    </Box>
                                                </Box>
                                                {onSubmit === true ? criteria.length > 0 ? criteria.length > 0 && checkDataOne(formik.values.criteria) === false ?
                                                    <Typography fontWeight="400" color="#d32f2f" fontSize="0.75rem" lineHeight="1.66" sx={{ position: "absolute", "margin-top": "3px", "margin-right": "14px", "margin-bottom": "0", "margin-left": "14px" }}>{t('admin.inputForm.msgError.code')}</Typography>
                                                    : null : null : null}
                                            </Box>
                                        </Box>
                                        <Box pt="17px" sx={{ width: "calc(100% - 80px)", margin: "0 40px" }}>
                                            <Box sx={{ position: "relative" }}>
                                                <Box mt="10px" sx={{ border: checkErrorCheckbox() ? "1px solid #138BFB" : "1px solid #CED4DA", "box-sizing": "border-box", "border-radius": "4px", padding: "17px 29px" }}>
                                                    <Box sx={{ display: "flex", "align-items": "center", "justify-content": "space-between" }} mb="15px">
                                                        <Box sx={{ display: "flex", "align-items": "center" }}>
                                                            <Typography fontWeight="500" color="#404349" fontSize={16} lineHeight="23.92px" display="flex" sx={{ textTransform: "uppercase" }}>RESULT</Typography>
                                                            {checkErrorCheckbox() ?
                                                                <Typography fontWeight="500" color="#138BFB" fontSize={14} lineHeight="23.92px" display="flex" sx={{ paddingLeft: "20px" }}>The selection is the same person but not the same form.</Typography>
                                                                : null
                                                            }
                                                        </Box>
                                                        {selected.length > 0 ?
                                                            <Box sx={{ backgroundColor: "#5DA1961A", padding: "9.05px 20px", borderRadius: "5px" }}>
                                                                <Typography color="#5DA196" fontSize={18} lineHeight="26.91px" fontWeight={400} >Selected Items: {selected.length}</Typography>
                                                            </Box>
                                                            : null
                                                        }
                                                    </Box>
                                                    <Divider />
                                                    <Box sx={{ overflow: "hidden", height: "100%", transition: "all .8s", "max-height": criteria !== undefined && criteria !== null && criteria.length > 0 ? "999999px" : "0px" }}>
                                                        {dataFormExist !== undefined && dataFormExist !== null && dataFormExist.length > 0 ?
                                                            <Box pb="16px">
                                                                <Typography mt="10px" fontWeight="400" color="#404349" fontSize={16} lineHeight="23.92px" display="flex">Showing {dataFormExist.length} results</Typography>
                                                                {/* <div className={classes.root}> */}
                                                                {/* <Paper className={classes.flexPaper} > */}
                                                                <Box sx={{ background: "#FAFAFA" }}>
                                                                    <Box
                                                                        py="15px"
                                                                        sx={{ display: "flex", "flex-direction": "row" }}
                                                                    >
                                                                        {/* 33.97+15+25.03+13+13 */}
                                                                        <Box sx={{ display: "flex", "flex-direction": "row", width: "33.97%" }} pr="20px">
                                                                            <Checkbox
                                                                                sx={{ margin: "0 20px", padding: "0" }}
                                                                                checked={dataFormExist.length > 0 && selected.length === dataFormExist.length}
                                                                                indeterminate={selected.length > 0 ? selected.length !== dataFormExist.length : false}
                                                                                onChange={handleSelectAllClick}
                                                                            />
                                                                            <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="300px" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                                                                {t('evaluation.employee')}
                                                                            </Typography>
                                                                        </Box>
                                                                        <Box sx={{ display: "flex", "flex-direction": "row", width: "26%" }} pr="20px">
                                                                            <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="300px" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                                                                {t('evaluation.evaluator')}
                                                                            </Typography>
                                                                        </Box>
                                                                        <Box sx={{ display: "flex", "flex-direction": "row", width: "25.03%" }} pr="20px">
                                                                            <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="300px" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                                                                {t('evaluation.evaluationForm')}
                                                                            </Typography>
                                                                        </Box>
                                                                        <Box sx={{ display: "flex", "flex-direction": "row", width: "15%" }} pr="20px">
                                                                            <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="300px" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                                                                {t('admin.inputForm.status')}
                                                                            </Typography>
                                                                        </Box>
                                                                    </Box>
                                                                </Box>
                                                                <Box sx={{ overflowY: "overlay", height: " calc(100vh - 200px)" }}>
                                                                    {dataFormExist !== undefined && dataFormExist !== null && dataFormExist.length > 0 ? dataFormExist.map((row, index) => {
                                                                        const isItemSelected = isSelected(row?.serial)
                                                                        return (
                                                                            <Box>
                                                                                <Box sx={{ width: "100%", position: "relative" }}>
                                                                                    <Box
                                                                                        sx={{ height: "70px", background: "#FFF", width: "100%", display: "flex", "align-items": "center" }}
                                                                                    >
                                                                                        {/* 33.97+15+25.03+13+13 */}
                                                                                        <Box sx={{ display: "flex", alignItems: "center", "flex-direction": "row", width: "33.97%" }} pr="20px">
                                                                                            <Box sx={{ display: "flex", alignItems: "center" }}
                                                                                                onClick={(event) => handleClick(event, row?.serial)}
                                                                                                role="checkbox"
                                                                                                aria-checked={isItemSelected}
                                                                                                tabIndex={-1}
                                                                                                key={row?.serial}
                                                                                                selected={isItemSelected}>
                                                                                                <Checkbox
                                                                                                    sx={{ margin: "0 20px", padding: "0", '&.Mui-checked': { color: () => handleSelectError(row.employee.serial) ? '#138BFB' : '#5DA196', } }}
                                                                                                    // onChange={e => changeType(data?.serial)} 
                                                                                                    checked={isItemSelected}
                                                                                                />
                                                                                            </Box>
                                                                                            <Box sx={{ width: "calc(100% - 60px)" }} >
                                                                                                <Typography fontSize={16} lineHeight="23.96px" color="#404349" fontWeight="400" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                                                                                    {Util.formatData(row?.employee?.fullname, "-")}
                                                                                                </Typography>
                                                                                                <Typography fontSize={16} lineHeight="23.96px" color="#AAAAAA" fontWeight="400" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                                                                                    {Util.formatData(row?.employee?.position, "-")} {Util.formatData(row?.employee?.organization, false) === false ? "" : `(${row?.employee?.organization})`}
                                                                                                </Typography>
                                                                                            </Box>
                                                                                        </Box>
                                                                                        <Box sx={{ display: "flex", alignItems: "center", "flex-direction": "row", width: "26%" }} pr="20px">
                                                                                            <Box sx={{ width: "calc(100% - 10px)" }} >
                                                                                                <Typography fontSize={16} lineHeight="23.96px" color="#404349" fontWeight="400" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                                                                                    {Util.formatData(row?.evaluator?.fullname, "-")}
                                                                                                </Typography>
                                                                                                <Typography fontSize={16} lineHeight="23.96px" color="#AAAAAA" fontWeight="400" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                                                                                    {Util.formatData(row?.evaluator?.position, "-")} {Util.formatData(row?.evaluator?.organization, false) === false ? "" : `(${row?.evaluator?.organization})`}
                                                                                                </Typography>
                                                                                            </Box>
                                                                                        </Box>
                                                                                        <Box sx={{ display: "flex", alignItems: "center", "flex-direction": "row", width: "25.03%" }} pr="20px">
                                                                                            <Typography fontSize={16} lineHeight="23.96px" color="#404349" fontWeight="400" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                                                                                {Util.formatData(row?.form?.name, "-")}
                                                                                            </Typography>
                                                                                        </Box>
                                                                                        <Box sx={{ display: "flex", alignItems: "center", "flex-direction": "row", width: "15%" }} pr="20px">
                                                                                            <Box py="8px" px="20px" sx={{ "max-width": "100%", width: "max-content", border: row?.status?.code === "not_started" ? "1px solid #DADADA" : "none", "border-radius": "5px", background: row?.status?.code === "in_progress" ? "#EFB76D1A" : row?.status?.code === "pending" ? "#FEF3EA" : row?.status?.code === "completed" || row?.status?.code === "approved" ? "#5DA1961A" : row?.status?.code === "deleted" ? "#8282821A" : "1px solid #DADADA" }} >
                                                                                                <Typography fontSize={16} lineHeight="24px" fontWeight={500} color={row?.status?.code === "in_progress" ? "#EFB76D" : row?.status?.code === "pending" ? "#F28026" : row?.status?.code === "completed" || row?.status?.code === "approved" ? "#5DA196" : row?.status?.code === "deleted" ? "#828282" : "#6B6B6B"} sx={{ "text-align": "center", "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                                                                                    {row?.status.name}
                                                                                                </Typography>
                                                                                            </Box>
                                                                                        </Box>
                                                                                    </Box>
                                                                                </Box>
                                                                                <Divider width="100%" />
                                                                            </Box>
                                                                        )
                                                                    })
                                                                        :
                                                                        <Box sx={{ "padding-top": "50px", "text-align": "center", "padding-bottom": "50px" }}>
                                                                            <Nodata />
                                                                            <Typography color="#A0A0A0" fontWeight="500" fontSize={20} lineHeight="30px" >
                                                                                {t('label.noData')}
                                                                            </Typography>
                                                                        </Box>
                                                                    }
                                                                </Box>
                                                                {/* </Paper> */}
                                                                {/* </div> */}
                                                            </Box>
                                                            :
                                                            <Box sx={{ "padding-top": "50px", "text-align": "center", "padding-bottom": "50px" }}>
                                                                <Nodata />
                                                                <Typography color="#A0A0A0" fontWeight="500" fontSize={20} lineHeight="30px" >
                                                                    {t('label.noData')}
                                                                </Typography>
                                                            </Box>
                                                        }
                                                    </Box>
                                                </Box>
                                            </Box>
                                        </Box>
                                        <Box pt="17px" sx={{ width: "calc(100% - 80px)", margin: "0 40px" }}>
                                            <Box sx={{ position: "relative" }}>
                                                <Box mt="10px" sx={{ border: "1px solid #CED4DA", "box-sizing": "border-box", "border-radius": "4px", padding: "17px 29px" }}>
                                                    <Box sx={{ display: "flex", "align-items": "center", "justify-content": "space-between" }} mb="15px">
                                                        <Typography fontWeight="500" color="#404349" fontSize={16} lineHeight="23.92px" display="flex" sx={{ textTransform: "uppercase" }}>NO FORM</Typography>
                                                    </Box>
                                                    <Divider />
                                                    <Box sx={{ overflow: "hidden", height: "100%", transition: "all .8s", "max-height": criteria !== undefined && criteria !== null && criteria.length > 0 ? "999999px" : "0px" }}>
                                                        {dataFormNotExist !== undefined && dataFormNotExist !== null && dataFormNotExist.length > 0 ?
                                                            <Box pb="16px">
                                                                <Typography mt="10px" fontWeight="400" color="#404349" fontSize={16} lineHeight="23.92px" display="flex">Showing {dataFormNotExist.length} results</Typography>
                                                                {/* <div className={classes.root}> */}
                                                                {/* <Paper className={classes.flexPaper} > */}
                                                                <Box sx={{ background: "#FAFAFA" }}>
                                                                    <Box
                                                                        py="15px"
                                                                        sx={{ display: "flex", "flex-direction": "row" }}
                                                                    >
                                                                        {/* 33.97+15+25.03+13+13 */}
                                                                        <Box sx={{ display: "flex", "flex-direction": "row", width: "33.97%" }} pr="20px">
                                                                            <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="300px" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                                                                {t('evaluation.employee')}
                                                                            </Typography>
                                                                        </Box>
                                                                        <Box sx={{ display: "flex", "flex-direction": "row", width: "26%" }} pr="20px">
                                                                            <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="300px" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                                                                {t('admin.label.yearOfService')}
                                                                            </Typography>
                                                                        </Box>
                                                                    </Box>
                                                                </Box>
                                                                <Box sx={{ overflowY: "overlay", height: " calc(100vh - 400px)" }}>
                                                                    {dataFormNotExist !== undefined && dataFormNotExist !== null && dataFormNotExist.length > 0 ? dataFormNotExist.map((row, index) => {
                                                                        return (
                                                                            <Box>
                                                                                <Box sx={{ width: "100%", position: "relative" }}>
                                                                                    <Box
                                                                                        sx={{ height: "70px", background: "#FFF", width: "100%", display: "flex", "align-items": "center" }}
                                                                                    >
                                                                                        {/* 33.97+15+25.03+13+13 */}
                                                                                        <Box sx={{ display: "flex", alignItems: "center", "flex-direction": "row", width: "33.97%" }} pr="20px">
                                                                                            <Box sx={{ width: "calc(100% - 60px)" }} >
                                                                                                <Typography fontSize={16} lineHeight="23.96px" color="#404349" fontWeight="400" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                                                                                    {Util.formatData(row?.fullname, "-")}
                                                                                                </Typography>
                                                                                                <Typography fontSize={16} lineHeight="23.96px" color="#AAAAAA" fontWeight="400" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                                                                                    {Util.formatData(row?.position, "-")} {Util.formatData(row?.organization, false) === false ? "" : `(${row?.organization})`}
                                                                                                </Typography>
                                                                                            </Box>
                                                                                        </Box>
                                                                                        <Box sx={{ display: "flex", alignItems: "center", "flex-direction": "row", width: "26%" }} pr="20px">
                                                                                            <Typography fontSize={16} lineHeight="23.96px" color="#404349" fontWeight="400" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                                                                                {Util.dateDayFormatAdmin(row?.employee_start_at, "-")}
                                                                                                ({showExp(row?.emp_exp)})
                                                                                            </Typography>
                                                                                        </Box>
                                                                                    </Box>
                                                                                </Box>
                                                                                <Divider width="100%" />
                                                                            </Box>
                                                                        )
                                                                    })
                                                                        :
                                                                        <Box sx={{ "padding-top": "50px", "text-align": "center", "padding-bottom": "50px" }}>
                                                                            <Nodata />
                                                                            <Typography color="#A0A0A0" fontWeight="500" fontSize={20} lineHeight="30px" >
                                                                                {t('label.noData')}
                                                                            </Typography>
                                                                        </Box>
                                                                    }
                                                                </Box>
                                                                {/* </Paper> */}
                                                                {/* </div> */}
                                                            </Box>
                                                            :
                                                            <Box sx={{ "padding-top": "50px", "text-align": "center", "padding-bottom": "50px" }}>
                                                                <Nodata />
                                                                <Typography color="#A0A0A0" fontWeight="500" fontSize={20} lineHeight="30px" >
                                                                    {t('label.noData')}
                                                                </Typography>
                                                            </Box>
                                                        }
                                                    </Box>
                                                </Box>
                                            </Box>
                                        </Box>
                                    </Box>
                                    <Box mt="30px">
                                        <Box display="flex" flexDirection="row-reverse">
                                            <Box sx={{ width: "100px" }}>
                                                <Button onClick={e => handleSubmit("submit")} color="primary" variant="contained" fullWidth sx={{ textTransform: "none", }} disabled={selected.length > 0 ? false : true}>
                                                    {t('label.create')}
                                                </Button>
                                            </Box>
                                            <Box mr={2} sx={{ width: "100px" }}>
                                                <Button color="black" variant="outlined" fullWidth onClick={handleCancel} sx={{ textTransform: "none", }}>
                                                    {t('label.cancel')}
                                                </Button>
                                            </Box>
                                        </Box>
                                    </Box>
                                </Paper>
                            </Grid>
                        </Grid>
                    </Grid>
                    <SimpleDialog
                        open={isSuccessAddDialogOpen}
                        doDirect={() => handleDirect()}
                        setValue={openSuccessAddDialog}
                        text={t('admin.label.calibrationSessionCreatedSuccessfully')}
                        page={true}
                    />
                    <MessageDialog
                        open={openFailedMessageDialog}
                        setValue={handleCloseFailedMessageDialog}
                        type="fail"
                        title={t(`dialog.label.fail`)}
                        text={t(`admin.label.calibrationSessionCreatedFail`)}
                    />
                    <ConfirmDialog open={discardDialog} warning={true} doConfirm={() => handleDiscardChangeConfirm()} setValue={() => handleDiscardDialog(false)} title={t('label.confirmationOfDiscard')} text={t('label.youSureDiscardChange')} />
                    <DialogPreview open={openPreview} data={formik.values} close={onClosePreview} />
                </Container>
            </Box >
        </>
    )
};
export default CalibrationSessionCreate;
